import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { localVerticalHead } from "@/config/seoLocal";
import { redirectLegacyMunicipality } from "@/lib/legacyRedirects";
import { assertServiceSlug } from "@/lib/slugGuards";

const ServiceSlugPage = lazy(() => import("@/pages/produkter/ServiceSlugPage"));

export const Route = createFileRoute("/hembatterier/$slug")({
  beforeLoad: ({ params }) => {
    redirectLegacyMunicipality("hembatterier", params.slug);
  },
  // Vertikalen har bara produktsidor – annars riktig 404.
  loader: ({ params }) => assertServiceSlug("hembatterier", params.slug, { municipalityPages: false }),
  head: ({ params }) => localVerticalHead("hembatterier", params.slug),
  component: () => <ServiceSlugPage vertical="hembatterier" fallback="none" />,
});
